<template>
  <Layout>
    <div class="row">
    <div class="col-md-3 col-6" v-for="item in smsbundles" :key="item.id">
      <div class="card">
        <div class="card-header rounded-2 bg-primary text-white h5">{{ item.package }}</div>
        <div class="card-body p-3 d-flex justify-content-between">
          <span class="text-danger"><span class="text-dark h6">{{ commas(item.sms) }}</span> <i>sms</i></span>
          <span class="text-danger"><span class="text-dark h6">{{ commas(item.total_cost) }} </span> <i>ugx</i></span>
        </div>
        <span class="d-flex justify-content-end mt-n2 m-2"><b-button @click="buy(item.id,item.package,item.sms,item.total_cost)" class="btn btn-dark"><i class="mdi mdi-cash"></i> buy</b-button></span>
      </div>
    </div>
    </div>
    <div class="card">
        <div class="card-body">
          <h4>SMS Purchases</h4>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm" :options="Options"></b-form-select> entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end" >
                  <label class="d-inline-flex align-items-center">
                    Search: <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table
                :items="Items"
                :fields="Fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="Filtered"
                :busy="IsBusy"
              >
              <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>No Data Found</strong></div></template>
              <template #cell(index)="data">
                {{ data.index + 1 }}
              </template>
              <template #cell(package)="data">
                {{ data.item.package.package }}
              </template>
              <template #cell(addedby)="data">
                {{ data.item.addedby.username }}
              </template>
              <template #cell(actions)="data">
                <div class="btn-group">
                <b-button @click="edit(data.item.id,data.item.name )" type="button" class="btn-sm btn" variant="primary" v-b-modal.edit> <i class="mdi mdi-square-edit-outline"></i> </b-button>
                <b-button @click="remove(data.item.id,data.item.name)" type="button" class="btn-sm btn" variant="danger"  v-b-modal.delete> <i class="mdi mdi-trash-can"></i> </b-button>
                </div>
              </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
      </div>

    <b-modal id="buy-package" centered :title="packagename" title-class="font-14" hide-footer>
        <form method="POST" :action="'https://pay.afrimedsolutions.com/?amount='+cost+'&sms='+sms+'&business='+userData.businessID">
            <div class="form-group mb-2">
              <input hidden name="gtp_Amount" v-model="cost">
              <h4>Buy {{ sms }} sms at   : {{ cost }} ugx </h4>
            </div>
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('buy-package')" >Close</b-button>
                <b-button type="submit" class="btn ms-1 w-30" variant="primary"><i class="fas fa-check-circle"></i> Submit </b-button>
            </div>
        </form>
    </b-modal>
  </Layout>
</template>

<script>
// import axios from "axios";
import Layout from "../../layouts/main";
import { smsBundleMethods, smsBundleComputed, smsPurchasesMethods, smsPurchasesComputed } from "@/state/helpers";

export default {
  components: { Layout  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
          { key: 'index', label: '#', visible: true },
          { key: 'id', label: 'ID', visible: false },
          { key: 'package', label: 'Package', visible: true },
          { key: 'telephone', label: 'Telephone', visible: true },
          { key: 'addedby', label: 'Purchased by', visible: true },
          { key: 'addedon', label: 'Purchased On', visible: true },
        ],
      id:'',
      packagename:'',
      cost:'',
      sms:'',
      telephone:'',
      paydate:"",
    };
  },
  computed: {
    ...smsBundleComputed,
    ...smsPurchasesComputed,
    List() { return this.smspurchases.length; },
    Fields() { return this.fields.filter(field => field.visible) },
    Items() { return this.smspurchases.map((d) => ({...d }))},
    IsBusy() { let a=false; if (this.smspurchases.length>0) { a=false;} else { a=true;} return a },
  },
  mounted() {
    this.fetchSmsBundles();
    this.fetchSmsPurchases();
    this.TotalRows = this.smspurchases.length;
    this.isBusy=false;
  },
  methods: {
    ...smsBundleMethods,
    ...smsPurchasesMethods,
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    commas(x) { return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); },
    buy(id,packagename,sms,cost){
      this.id=id;
      this.packagename=packagename+" bundles";
      this.cost=cost;
      this.sms=sms;
      this.$bvModal.show('buy-package')
    },
  },
};
</script>